<div class="content-with-stepper-and-title">
    <div class="row">
        <div class="col-4 col-pr-12 col-sm-8 col-md-12">
            <div class="box-title">
                <p class="sub-title" id="subtitle">
                    {{ copyService.copies.support_documents_loan.title }}
                </p>
            </div>
            <div id="steps">
                <ul class="mt-3">
                  <vcl-list>
                      <li *ngFor="let document of documents" vclListSimple>
                          <span id="iconCheck" class="icon icon-itaufonts_check">
                          </span>
                          <vcl-list-text class="list">
                              {{ document }}
                          </vcl-list-text>
                      </li>
                  </vcl-list>
                </ul>
            </div>
            <div class="mt-3">
                <p>
                    {{ copyService.copies.support_documents_loan.footer }}
                    <a class="link_cursor">
                        <u>{{ copyService.copies.support_documents_loan.link }}</u>
                    </a>
                </p>
            </div>
        </div>
    </div>
    <app-controls [hasPrevious]="false" (next)="next()"></app-controls>
</div>